import { render, staticRenderFns } from "./BaDashboard.vue?vue&type=template&id=7d2fa3cc&"
import script from "./BaDashboard.vue?vue&type=script&lang=js&"
export * from "./BaDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports